import { createFileRoute } from '@tanstack/react-router';
import { CreateProspectPage } from '../../../features/crm';
import { usePageTitle } from '../../../lib/hooks';

export const Route = createFileRoute('/_auth/crm/new')({
  component: NewProspectRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === 'string' ? search.from : undefined,
  }),
});

function NewProspectRoute() {
  usePageTitle('New Prospect');
  const { from } = Route.useSearch();
  return <CreateProspectPage backTo={from === 'leads' ? '/crm/leads' : '/crm/prospects'} />;
}
